import React, { useState, useEffect } from 'react';

const ComponentSubcategoryForm = ({ subcategory, categories, onSave, onCancel }) => {
  const [formData, setFormData] = useState({
    subcategory_name: '',
    subcategory_description: '',
    component_category_id: ''
  });

  useEffect(() => {
    if (subcategory) {
      setFormData({
        subcategory_name: subcategory.subcategory_name || '',
        subcategory_description: subcategory.subcategory_description || '',
        component_category_id: subcategory.component_category_id || ''
      });
    } else if (categories.length > 0) {
      setFormData(f => ({ ...f, component_category_id: categories[0].component_category_id }));
    }
  }, [subcategory, categories]);

  const handleChange = e => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = e => {
    e.preventDefault();
    onSave(formData);
  };

  return (
    <form onSubmit={handleSubmit}>
      <label>
        Subcategory Name:
        <input
          name="subcategory_name"
          value={formData.subcategory_name}
          onChange={handleChange}
          required
        />
      </label>
      <label>
        Description:
        <input
          name="subcategory_description"
          value={formData.subcategory_description}
          onChange={handleChange}
        />
      </label>
      <label>
        Category:
        <select
          name="component_category_id"
          value={formData.component_category_id}
          onChange={handleChange}
          required
        >
          {categories.map(cat => (
            <option key={cat.component_category_id} value={cat.component_category_id}>
              {cat.category_name}
            </option>
          ))}
        </select>
      </label>
      <button type="submit">Save</button>
      <button type="button" onClick={onCancel}>Cancel</button>
    </form>
  );
};

export default ComponentSubcategoryForm;